import axios from "@/axios/axios";
import * as jwtUtil from "@/utils/jwtUtil";
import { ROLE } from "@/data/role";
import * as validationUtil from "@/utils/validationUtil";

//const KAKAO_REDIRECT_URI = "http://localhost:8081/auth"
const KAKAO_REDIRECT_URI = "http://newagingplatform-b2c.co.kr/auth";

export default {
  namespaced: true,
  state: {
    isAuth: false,
    user: {},
    isChecked: false, // 개인, 기업 프로필 필수값 검증 상태
    rejectNoties: [],
    showNoti: localStorage.getItem("showNoti"),
  },
  mutations: {
    setAuth: (state, isAuth) => (state.isAuth = isAuth),
    setUser: (state, user) => (state.user = user),
    setRejectNoties: (state, rejectNoties) =>
      (state.rejectNoties = rejectNoties),
    setChecked: (state, isChecked) => (state.isChecked = isChecked),
    reset: (state) => {
      localStorage.removeItem(jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN, "");
      localStorage.removeItem(jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN, "");
      state.isAuth = false;
      state.user = null;
      state.isChecked = false;
    },
    setShowNoti: (state, val) => {
      localStorage.setItem("showNoti", val);
      state.showNoti = val;
    },
  },
  getters: {
    getKakaoRedirectUri: () => KAKAO_REDIRECT_URI,
    isAuth: (state) => state.isAuth,
    getUser: (state) => state.user || {},
    isChecked: (state) => state.isChecked,
    getRejectNoties: (state) => state.rejectNoties,
    getShowNoti: (state) => state.showNoti,
  },
  actions: {
    resetPassword(context, payload) {
      return axios
        .post("/api/auth/resetPassword", {
          userIdx: payload.userIdx,
          phoneNumber: payload.phoneNumber,
          id: payload.id,
          password: payload.password,
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    authForResetPassword(context, payload) {
      return axios
        .post("/api/auth/authForResetPassword", null, {
          params: {
            id: payload.id,
            phoneNumber: payload.phoneNumber,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    searchId(context, phoneNumber) {
      return axios
        .post("/api/auth/searchId", phoneNumber)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    refreshAccessToken({ commit }) {
      return axios
        .post("/api/auth/refreshAccessToken", {
          refreshToken: localStorage.getItem(
            jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN
          ),
        })
        .then((response) => {
          var data = response.data;

          if (data != null) {
            console.log("Access token refreshed!!");

            // Local Storage에 JWT 저장
            localStorage.setItem(
              jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN,
              data.accessToken
            );
          }

          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log("Refresh access token failed...");
          console.log(error.response);

          // Access Token 갱신 실패 시 사용자 정보 삭제 및 인증상태 변경
          commit("reset");

          return Promise.reject(error);
        });
    },
    isAlreadyExistUsername(context, username) {
      return axios
        .post("/api/auth/isAlreadyExistUsername", username)
        .then((response) => {
          var data = response.data;
          console.log(data);
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error.response);
          return Promise.reject(error);
        });
    },
    signup(context, payload) {
      if (payload.birthday) payload.birthday = parseInt(payload.birthday);
      if (payload.phoneNumber) payload.phone = payload.phoneNumber;
      if (payload.classification)
        payload.classification = parseInt(payload.classification);

      return axios
        .post("/api/account/signup/individual", payload)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error.response);
          return Promise.reject(error);
        });
    },
    signupCorp(_, payload) {
      return axios
        .post("/api/account/signup/corp", payload)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error.response);
          return Promise.reject(error);
        });
    },
    signin({ commit }, payload) {
      return axios
        .post("/api/auth/signin", {
          username: payload.id,
          password: payload.password,
        })
        .then((response) => {
          var data = response.data;

          if (data != null) {
            // Local Storage에 JWT 저장
            localStorage.setItem(
              jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN,
              data.accessToken
            );
            localStorage.setItem(
              jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN,
              data.refreshToken
            );

            // Store에 사용자 정보 및 인증상태 저장
            commit("setAuth", true);
            commit("setUser", data.user);

            // 프로필 필수값 검사
            var isPass = true;

            switch (data.user.roleName) {
              case ROLE.USER:
                // 개인:  휴대폰번호 이름 생년월일 성별 시군구
                if (
                  validationUtil.isEmpty(data.user.phoneNumber) ||
                  validationUtil.isEmpty(data.user.name) ||
                  validationUtil.isEmpty(data.user.birthday) ||
                  validationUtil.isEmpty(data.user.gender)
                  // validationUtil.isEmpty(data.user.address) ||
                  // validationUtil.isEmpty(data.user.addressDetail)
                ) {
                  isPass = false;
                }
                break;
              case ROLE.CORP:
                // 기업: 담당자명 담당자전화번호 기업명 설립연도 매출규모 사원수  업종 기업형태 주소 상세주소
                if (
                  validationUtil.isEmpty(data.user.phoneNumber) ||
                  validationUtil.isEmpty(data.user.name) ||
                  validationUtil.isEmpty(data.user.company) ||
                  validationUtil.isEmpty(data.user.birthday) ||
                  validationUtil.isEmpty(data.user.profitSize) ||
                  validationUtil.isEmpty(data.user.memberSize) ||
                  validationUtil.isEmpty(data.user.fieldType) ||
                  validationUtil.isEmpty(data.user.companyType) ||
                  validationUtil.isEmpty(data.user.address) ||
                  validationUtil.isEmpty(data.user.addressDetail)
                ) {
                  isPass = false;
                }
                break;
              default:
                break;
            }

            commit("setChecked", isPass);
          }

          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error.response);
          return Promise.reject(error);
        });
    },
    signinKakao({ commit }, code) {
      return axios
        .post("/api/auth/signin/kakao", {
          code: code,
          redirectUri: KAKAO_REDIRECT_URI,
        })
        .then((response) => {
          var data = response.data;

          if (data != null) {
            // Local Storage에 JWT 저장
            localStorage.setItem(
              jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN,
              data.accessToken
            );
            localStorage.setItem(
              jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN,
              data.refreshToken
            );

            // Store에 사용자 정보 및 인증상태 저장
            commit("setAuth", true);
            commit("setUser", data.user);

            // 프로필 필수값 검사
            var isPass = true;

            switch (data.user.roleName) {
              case ROLE.USER:
                // 개인:  휴대폰번호 이름 생년월일 성별 시군구
                if (
                  validationUtil.isEmpty(data.user.phoneNumber) ||
                  validationUtil.isEmpty(data.user.name) ||
                  validationUtil.isEmpty(data.user.birthday) ||
                  validationUtil.isEmpty(data.user.gender) ||
                  validationUtil.isEmpty(data.user.address) ||
                  validationUtil.isEmpty(data.user.addressDetail)
                ) {
                  isPass = false;
                }
                break;
              case ROLE.CORP:
                // 기업: 담당자명 담당자전화번호 기업명 설립연도 매출규모 사원수  업종 기업형태 주소 상세주소
                if (
                  validationUtil.isEmpty(data.user.phoneNumber) ||
                  validationUtil.isEmpty(data.user.name) ||
                  validationUtil.isEmpty(data.user.company) ||
                  validationUtil.isEmpty(data.user.birthday) ||
                  validationUtil.isEmpty(data.user.profitSize) ||
                  validationUtil.isEmpty(data.user.memberSize) ||
                  validationUtil.isEmpty(data.user.fieldType) ||
                  validationUtil.isEmpty(data.user.companyType) ||
                  validationUtil.isEmpty(data.user.address) ||
                  validationUtil.isEmpty(data.user.addressDetail)
                ) {
                  isPass = false;
                }
                break;
              default:
                break;
            }

            commit("setChecked", isPass);
          }

          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error.response);
          return Promise.reject(error);
        });
    },
    signout({ commit }, payload) {
      return axios
        .post("/api/auth/signout", {
          userIdx: payload.userIdx,
          refreshToken: payload.refreshToken,
        })
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          console.log(error.response);
        })
        .finally(() => {
          // 성공, 실패 관련 없이 로그인 정보 삭제
          commit("reset");
          return Promise.resolve();
        });
    },
    getProfileRejectNotices({ commit }) {
      return axios
        .get("/api/account/get-profile")
        .then((res) => {
          if (res.status == 200) {
            commit("setRejectNoties", res.data.rejectNoties);
            if (res.data.rejectNoties.length > 0) {
              commit("setShowNoti", true);
            } else {
              commit("setShowNoti", false);
            }
            return Promise.resolve(res);
          }

          return Promise.reject(res.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    clearNotify({ commit }) {
      return axios
        .get("/api/account/clear-noties")
        .then((res) => {
          if (res.status == 200) {
            commit("setRejectNoties", []);
            commit("setShowNoti", false);
            return Promise.resolve(res);
          }

          return Promise.reject(res.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    }
  },
};
